import { CropState } from "../../types";

export const toggleCropOrientation = (state: CropState) => {
    const width = state.crop.width;
    const height = state.crop.height;

    state.crop.height = width;
    state.crop.width = height;
};
